// Generic typed fetch helper — used by pages that don't fit the object engine
// shape (e.g. forms, workflows, settings).

const API_BASE =
  (import.meta as any).env?.VITE_API_BASE ??
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? '/api'
    : 'https://thehub-api.hphcorp.workers.dev');

export async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!headers.has('Content-Type') && init.body) {
    headers.set('Content-Type', 'application/json');
  }
  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost' &&
    !headers.has('Authorization')
  ) {
    headers.set(
      'Authorization',
      'Bearer dev:01WORKSPACE0000000000000DEF:01USER000000000000000ADMIN',
    );
  }
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
  const res = await fetch(url, { ...init, credentials: 'include', headers });
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText}: ${detail}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
